// extracted by mini-css-extract-plugin
export default {"list":"owMl-","item":"_1Hz0t","link":"_2lI2t","label":"_1zHCJ","icon":"_2RocO","itemSelected":"ImQrj","caption":"_1wDmw","iconWithBackground":"_1QxY3","matchesCount":"_1TXJC"};